'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { duoColorIconRecipe } from './styles/duo-color-icon.styles';
import type { DuoColorIconPropsInterface } from './types/duo-color-icon.types';

/**
 * `DuoColorIcon` is a component that renders a color icon with a background color
 * and a foreground color based on the `onBackground` and `tone` options.
 *
 * @since 10.2.0
 */

export const DuoColorIcon = forwardRef<HTMLDivElement, DuoColorIconPropsInterface>(
  (props: DuoColorIconPropsInterface, forwardedRef) => {
    const {
      className,
      children,
      css: cssProp,
      tone = 'trust',
      onBackground = 'default',
      ...rest
    } = props;

    const styles = css(duoColorIconRecipe.raw({ tone, onBackground }), cssProp);

    return (
      <div
        ref={forwardedRef}
        className={cx('c11n', 'c11n_duo-color-icon', styles, className)}
        data-c11n-component="DuoColorIcon"
        data-c11n-version={__C11N_VERSION__}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DuoColorIcon.displayName = 'DuoColorIcon';
